<div class="forms-container">
  @for (form of forms().controls; track form; let idx = $index) {
    <ai-tool-parameter-form [form]="form" (remove)="handleRemove(idx)" />
  }
</div>
@if (forms().enabled) {
  <button mat-button color="primary" type="button" class="add-parameter" (click)="handleAdd()">
    {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.ADD_PARAMETER' | translate }}
  </button>
}
